import React from 'react'
import './OverviewTabContent.css'
import parse from "html-react-parser";
const OverviewTabContent = ({product}) => {
    return (
        <section className='OverviewTabContent'>
            <div className='row'>
                <div className='col-lg-7 order-lg-1 order-2'>
                    <div className='left_side'>
                        <p>{parse(String(product?.overview || ""))}</p>
                        {/* <p className='heading'>{parse(product?.overview)||""}</p> */}

                        {/* <p className='descn'>
                            Your Business Card Is Often The First Physical Touchpoint With Potential Clients. Make It Unforgettable With Our Metallic Business Cards.
                            These Aren't Just Cards; They're A Statement Of Luxury And Innovation. With Shimmering Silver And Gold Options, Your Brand Will Command
                            Attention.
                        </p>

                        <p className='descn'>
                            Ideal For Industries That Thrive On Creativity And Style, Our Metallic Business Cards Are Designed To Leave A Lasting Impression.
                            Whether You're Networking At A High-Profile Event Or Handing Out Your Card In A Casual Setting, This Premium Card Elevates Your
                            Professional Image. Make Every Exchange Count With A Business Card That Truly Reflects Your Brand's Brilliance.
                        </p> */}

                    </div>
                </div>
                <div className='col-lg-5 order-lg-2 order-1'>
                    {/* <div className='rigth_side'>
                        <div className='img_holder'>
                            <img src='\assets\Images\overviewtabs\img.png' className='img'/>
                        </div>
                    </div> */}
                </div>
            </div>
        </section>
    )
}

export default OverviewTabContent
